import { isObject } from './isObject';

export const isObjectWith = <T extends string>(value: unknown, property: T): value is { [key in T]: unknown } => {
  return isObject(value) && property in value;
};
